/**
 * MinaRoMina Wallpaper Gallery - JavaScript
 * Inicialización de PhotoSwipe para galería vertical
 */

(function() {
  'use strict';

  // Track initialized galleries to prevent duplicate initialization
  const initializedGalleries = new Set();

  /**
   * Initialize wallpaper gallery with PhotoSwipe
   * @param {string} galleryId - ID of the gallery element
   */
  function initWallpaperGallery(galleryId) {
    if (!galleryId || initializedGalleries.has(galleryId)) {
      return;
    }

    const galleryEl = document.getElementById(galleryId);
    if (!galleryEl) {
      console.warn('[MRM Wallpaper] Gallery not found:', galleryId);
      return;
    }

    // Check if PhotoSwipe is available
    if (typeof PhotoSwipeLightbox === 'undefined' || typeof PhotoSwipe === 'undefined') {
      console.warn('[MRM Wallpaper] PhotoSwipe not loaded, retrying...');
      setTimeout(() => initWallpaperGallery(galleryId), 500);
      return;
    }

    try {
      const lightbox = new PhotoSwipeLightbox({
        gallery: '#' + galleryId,
        children: 'a.mrm-wallpaper-item',
        pswpModule: PhotoSwipe,

        // UI options
        showHideAnimationType: 'fade',
        showAnimationDuration: 333,
        hideAnimationDuration: 333,

        // Zoom options
        zoom: true,
        wheelToZoom: true,
        pinchToClose: true,

        // Layout
        padding: { top: 20, bottom: 40, left: 20, right: 20 },

        // Preload
        preload: [1, 2],
      });

      // Add event listeners
      lightbox.on('uiRegister', function() {
        // Custom UI elements can be added here
        console.log('[MRM Wallpaper] PhotoSwipe UI registered');
      });

      lightbox.init();
      initializedGalleries.add(galleryId);

      console.log('[MRM Wallpaper] ✅ Gallery initialized:', galleryId);
    } catch (error) {
      console.error('[MRM Wallpaper] Initialization error:', error);
    }
  }

  /**
   * Initialize all wallpaper galleries on the page
   */
  function initAllGalleries() {
    const galleries = document.querySelectorAll('[id^="WallpaperGallery-"]');

    galleries.forEach(function(gallery) {
      if (gallery.id && !initializedGalleries.has(gallery.id)) {
        initWallpaperGallery(gallery.id);
      }
    });

    if (galleries.length === 0) {
      console.log('[MRM Wallpaper] No galleries found on page');
    }
  }

  /**
   * Cleanup gallery when section is removed (theme editor)
   * @param {string} galleryId - ID of the gallery to cleanup
   */
  function cleanupGallery(galleryId) {
    if (initializedGalleries.has(galleryId)) {
      initializedGalleries.delete(galleryId);
      console.log('[MRM Wallpaper] Gallery cleaned up:', galleryId);
    }
  }

  // Initialize on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllGalleries);
  } else {
    initAllGalleries();
  }

  // Theme editor support
  if (window.Shopify && window.Shopify.designMode) {
    // Re-initialize when section is loaded/reloaded
    document.addEventListener('shopify:section:load', function(e) {
      if (e.detail && e.detail.sectionId) {
        const galleryId = 'WallpaperGallery-' + e.detail.sectionId;
        setTimeout(() => initWallpaperGallery(galleryId), 100);
      }
    });

    // Cleanup when section is unloaded
    document.addEventListener('shopify:section:unload', function(e) {
      if (e.detail && e.detail.sectionId) {
        const galleryId = 'WallpaperGallery-' + e.detail.sectionId;
        cleanupGallery(galleryId);
      }
    });
  }

  // Export for debugging (only in development)
  if (window.location.hostname === 'localhost' || window.location.hostname.includes('.myshopify.com')) {
    window.mrmWallpaper = {
      init: initWallpaperGallery,
      initAll: initAllGalleries,
      cleanup: cleanupGallery,
      galleries: initializedGalleries
    };
  }

  console.log('[MRM Wallpaper] Script loaded and ready');
})();
